module.exports = __webpack_public_path__ + "img/lead-06z.dc7af336.png";